<template>
  <q-form
    autocomplete="off"
    @submit="() => {}"
  >
    <page-banner
      v-if="!!errorMessage"
      :label="errorMessage"
      color="red-7"
      dense
      dark
      icon="mdi-exclamation-thick"
      class="q-mb-md"
    />

    <div>
      <q-item-label class="text-bold">
        Address line <span v-if="required" class="required-astrx" />
      </q-item-label>
      <AddressSearchLine
        ref="searchLine"
        v-bind="inputProps"
        :disable="disable"
        :readonly="readonly"
        :address="address"
        :autocomplete-options="autocompleteOptions"
        :search-loading="searchLoading"
        :suggestions-label="suggestionsLabel"
        :allow-refresh-suggestions="allowRefreshSuggestions"
        :suggestions="suggestions"
        name="address_line_1"
        hide-bottom-space
        @clear="onClickClearLine1"
        @load-suggestions="$emit('loadSuggestions')"
        @refresh-suggestions="$emit('refreshSuggestions')"
      />
    </div>

    <div class="row q-col-gutter-md q-pt-md">
      <div class="col-6">
        <q-item-label class="text-bold">
          City/Suburb
        </q-item-label>
        <q-input
          v-model="address.locality"
          v-bind="inputProps"
          clearable
          hide-bottom-space
          name="suburb"
          :max="50"
          :disable="disable"
          :readonly="readonly"
          @update:model-value="removeGeocode"
        />
      </div>

      <div class="col-6">
        <q-item-label class="text-bold">
          Postcode
        </q-item-label>
        <q-input
          v-model="address.postal_code"
          v-bind="inputProps"
          clearable
          hide-bottom-space
          name="postcode"
          :max="10"
          :disable="disable"
          :readonly="readonly"
          @update:model-value="removeGeocode"
        />
      </div>
    </div>

    <div class="row q-col-gutter-md q-pt-md">
      <div class="col-6">
        <q-item-label class="text-bold">
          State
        </q-item-label>
        <q-input
          v-model="address.state"
          v-bind="inputProps"
          clearable
          hide-bottom-space
          name="state"
          :max="30"
          :disable="disable"
          :readonly="readonly"
          @update:model-value="removeGeocode"
        />
      </div>
      <div class="col-6">
        <q-item-label class="text-bold">
          Country
        </q-item-label>
        <q-input
          v-model="address.country"
          v-bind="inputProps"
          clearable
          hide-bottom-space
          name="country"
          :max="50"
          :disable="disable"
          :readonly="readonly"
          @update:model-value="removeGeocode"
        />
      </div>
    </div>

    <q-bar class="q-mt-sm q-pa-none bg-transparent">
      <q-space />
      <q-btn
        v-if="!isCleared"
        dense
        no-caps
        size="12px"
        label="Clear All"
        flat
        color="orange-8"
        @click="onClickClearAll"
      />
    </q-bar>
  </q-form>
</template>

<script>
import AddressSearchLine from 'components/partials/address/AddressSearchLine.vue'
import searchMixin from 'components/partials/address/searchMixin'

/**
 * AddressInputContainer wraps all separate address fields including SearchLine
 */
export default {
  components: {
    AddressSearchLine
  },
  mixins: [searchMixin],
  props: {
    address: {
      type: Object,
      required: true
    },
    // Display * for address line 1
    required: {
      type: Boolean,
      default: false
    },
    // Disable editing all fields
    disable: {
      type: Boolean,
      default: false
    },
    // Make all fields readonly
    readonly: {
      type: Boolean,
      default: false
    },
    // Attach additional props to all QInputs
    inputProps: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // Display error msg above inputs
    errorMessage: {
      type: String,
      default: null
    },
    // If address fields are not blank, display a "Clear all" btn
    isCleared: {
      type: Boolean,
      required: true
    }
  },
  emits: ['clear'],
  methods: {
    focus () {
      if (this.$refs.searchLine) {
        this.$refs.searchLine.focus()
      }
    },
    onClickClearLine1 () {
      this.address.address_line_1 = null

      this.$nextTick(() => {
        this.$emit('clear')
      })
    },
    removeGeocode () {
      this.address.latitude = null
      this.address.longitude = null
    },
    onClickClearAll () {
      this.address.address_line_1 = null
      this.address.locality = null
      this.address.postal_code = null
      this.address.state = null
      this.address.country = null
      this.removeGeocode()
    }
  }
}
</script>
